export default theme => ({
  Root: {
    display: 'flex',
    flexDirection: 'column',
  },
})
